import request from "root/js/request";

export const getProductsPriceAndDiccont = async ({
  cabinet_id,
  shares_id,
  modal_type,
  in_shares,
}) => {
  const response = await request({
    url: `analytics/shares_products/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    params: {
      modal_type,
      in_shares,
    },
    method: "get",
  });
  return response;
};

export const postProductsPriceAndDiccont = async ({ cabinet_id, shares_id, products }) => {
  const response = await request({
    url: `analytics/shares_products/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    data: products,
    method: "post",
  });
  return response;
};
